export default __webpack_public_path__ + "static/media/password-generator.4989bf7d.png";